var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "BankTransaction" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Code",
                        error: _vm.$v.form.Code,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "DocumentDate",
                        error: _vm.$v.form.DocumentDate,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.DocumentDate },
                        model: {
                          value: _vm.form.DocumentDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "DocumentDate", $$v)
                          },
                          expression: "form.DocumentDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.detail"), active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerId",
                            error: _vm.$v.form.CustomerId,
                            md: "6",
                            lg: "6"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              searchable: true,
                              "custom-option": true,
                              "or-condition-fields":
                                "Code,Description1,CommercialTitle",
                              "is-customer": true,
                              disabled: _vm.insertReadonly.CustomerId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CustomerId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrencyId",
                            error: _vm.$v.form.CurrencyId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextSystem/api/SysCurrency/Search",
                              disabled: _vm.insertReadonly.CurrencyId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CurrencyId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TransactionTypeId",
                            error: _vm.$v.form.TransactionTypeId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextBank/api/BankTransactionType/Search",
                              disabled: _vm.insertReadonly.TransactionTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "TransactionTypeId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BankId",
                            error: _vm.$v.form.BankId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextBank/api/Bank/AutoCompleteSearch",
                              searchable: "",
                              disabled: _vm.insertReadonly.BankId
                            },
                            on: {
                              input: function($event) {
                                return _vm.getBranchs(
                                  $event,
                                  "BankId",
                                  "bankBranch",
                                  "bankBranches"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BankBranchId",
                            error: _vm.$v.form.BankBranchId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.bankBranches,
                              disabled:
                                _vm.insertReadonly.BankBranchId ||
                                !_vm.form.BankId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "BankBranchId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.bankBranch,
                              callback: function($$v) {
                                _vm.bankBranch = $$v
                              },
                              expression: "bankBranch"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BankAccountNumber",
                            error: _vm.$v.form.BankAccountNumber,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.BankAccountNumber
                            },
                            model: {
                              value: _vm.form.BankAccountNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "BankAccountNumber", $$v)
                              },
                              expression: "form.BankAccountNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DocumentNumber",
                            error: _vm.$v.form.DocumentNumber,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.DocumentNumber
                            },
                            model: {
                              value: _vm.form.DocumentNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DocumentNumber", $$v)
                              },
                              expression: "form.DocumentNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerBankId",
                            error: _vm.$v.form.CustomerBankId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextBank/api/Bank/AutoCompleteSearch",
                              searchable: "",
                              disabled: _vm.insertReadonly.CustomerBankId
                            },
                            on: {
                              input: function($event) {
                                return _vm.getBranchs(
                                  $event,
                                  "CustomerBankId",
                                  "customerBankBranch",
                                  "customerBankBranches"
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerBankBranchId",
                            error: _vm.$v.form.CustomerBankBranchId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.customerBankBranches,
                              disabled:
                                _vm.insertReadonly.CustomerBankBranchId ||
                                !_vm.form.CustomerBankId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CustomerBankBranchId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customerBankBranch,
                              callback: function($$v) {
                                _vm.customerBankBranch = $$v
                              },
                              expression: "customerBankBranch"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerBankAccountNumber",
                            error: _vm.$v.form.CustomerBankAccountNumber,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled:
                                _vm.insertReadonly.CustomerBankAccountNumber
                            },
                            model: {
                              value: _vm.form.CustomerBankAccountNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "CustomerBankAccountNumber",
                                  $$v
                                )
                              },
                              expression: "form.CustomerBankAccountNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TransactionTotal",
                            error: _vm.$v.form.TransactionTotal,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              min: "1",
                              disabled: _vm.insertReadonly.TransactionTotal
                            },
                            on: {
                              keypress: function($event) {
                                return _vm.onlyForCurrencyDotOrComma($event)
                              }
                            },
                            model: {
                              value: _vm.form.TransactionTotal,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TransactionTotal", $$v)
                              },
                              expression: "form.TransactionTotal"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a44170a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a44170a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BankTransaction/insert.vue
// module id = null
// module chunks = 